<template>
  <div class="animated fadeIn card">
    <flash :fields="['avatarMedia', 'UnprocessableEntity']"></flash>
    <div class="card-header"><h1>Perfil do usuário</h1></div>
    <div class="card-body">
      <b-form @submit.prevent.stop="onSubmit" @reset.prevent="onReset" v-if="show && ready">
          <div class="row">
            <b-form-group class="col-12 col-md-6 is-valid"
              label="Nome Completo"
              label-for="name"
              description="">

              <b-form-input id="name"
                type="text"
                v-model="form.name"
                required
                placeholder="Nome Completo"
                :class="{
                  'is-invalid': submitted && form.errors.has('name'),
                  'is-valid': submitted && !form.errors.has('name')
                }"></b-form-input>
            </b-form-group>

            <b-form-group class="col-12 col-md-6"
              label="Email"
              label-for="email"
              description="">

              <b-form-input id="email"
                type="text"
                v-model="form.email"
                required
                placeholder="Email"
                :class="{
                  'is-invalid': submitted && form.errors.has('email'),
                  'is-valid': submitted && !form.errors.has('email')
                }"></b-form-input>
            </b-form-group>

            <div class="col-12 text-right">
              <a href="#" @click.prevent.stop="togglePassword">
                <small>{{ updatePassword ? 'Ocultar' : 'Alterar Senha' }}</small>
              </a>
            </div>

            <template v-if="updatePassword">
              <b-form-group class="col-12 col-md-6"
                label="Senha"
                label-for="password"
                description="Apenas preencha os campos de senha se você quiser atualiza-la">

                <b-form-input id="password"
                  type="password"
                  v-model="form.password"
                  placeholder="***"
                  :class="{
                    'is-invalid': submitted && form.errors.has('password'),
                    'is-valid': submitted && !form.errors.has('password')
                  }"></b-form-input>
              </b-form-group>

              <b-form-group class="col-12 col-md-6"
                label="Confirmação Senha"
                label-for="password_confirmation"
                description="">

                <b-form-input id="password_confirmation"
                  type="password"
                  v-model="form.password_confirmation"
                  placeholder="***"
                  :class="{
                    'is-invalid': submitted && form.errors.has('password'),
                    'is-valid': submitted && !form.errors.has('password')
                  }"></b-form-input>
              </b-form-group>
            </template>
          </div>

        <hr/>

        <div class="text-right">
          <b-button type="submit" variant="success">
            Atualizar
          </b-button>
        </div>
      </b-form>
      </div>
  </div>
</template>

<script>
import { isEmpty } from 'lodash'
import { mapActions, mapGetters, mapState } from 'vuex'
import Users from '@/services/api/sys-users'
import Form from '@/services/form'

export default {
  data () {
    return {
      show: true,
      processing: false,
      submitted: false,

      updatePassword: false,

      form: new Form({
        name: '',
        email: '',
        password: '',
        password_confirmation: ''
      }),

      empty: {
        name: '',
        email: ''
      }
    }
  },

  watch: {
    loggedUser (value) {
      this.setFormData(value)
    }
  },

  computed: {
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
      loggedUser: 'auth/user'
    }),

    ...mapState({
      token: 'auth/token'
    }),

    ready: {
      get () {
        const ready = this.$auth.ready() && this.isAuthenticated && !isEmpty(this.loggedUser)

        if (ready) {
          this.onReset()
        }

        return ready
      },
      set () {
        //
      }
    },

    avatarUrl () {
      return Users.avatarUrl(this.loggedUser)
    }
  },

  methods: {
    ...mapActions({
      refreshTokenAndUser: 'auth/refreshTokenAndUser',
      fetchUser: 'auth/fetchUser'
    }),

    togglePassword () {
      this.updatePassword = !this.updatePassword

      if (!this.updatePassword) {
        this.form.password = ''
        this.form.password_confirmation = ''
      }
    },

    onSubmit () {
      const self = this

      self.processing = true
      self.submitted = false

      if (!self.updatePassword) {
        delete self.form.password
        delete self.form.password_confirmation
      }

      self.form.put(Users.getRoute('update', self.loggedUser.id))
        .then((data) => {
          self.submitted = true
          self.processing = false

          self.$toasted.success('Usuário atualizado com sucesso')

          // push success toast
          self.setFormData(data)
          self.fetchUser()
        }).catch((e) => {
          // self.$toasted.error('Perfil não foi atualizado. Contate o suporte.')

          self.submitted = true
          self.processing = false
        })
    },

    onReset () {
      /* Reset our form values */
      this.form.reset()
      this.submitted = false

      /* Trick to reset/clear native browser form validation state */
      this.show = false
      this.$nextTick(() => { this.show = true })
    },

    setFormData (userData) {
      this.form = new Form({
        name: userData.name,
        email: userData.email,
        password: '',
        password_confirmation: ''
      })
    }
  },

  created () {
    const self = this

    self.setFormData(self.loggedUser || self.empty)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Profile.vue